import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Alert from 'components/Alert/Alert'
import { selectAlerts, removeAlert } from 'store/global'
import styles from './Alerts.scss'

type AlertType = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info'

interface AlertData {
  id: string
  type: AlertType
  message: string
}

const Alerts: React.FC = () => {
  const dispatch = useDispatch()
  const alerts = useSelector(selectAlerts)

  const onDismiss = (id: string) => dispatch(removeAlert({ id }))

  const mapAlertType = (type: AlertType): 'success' | 'info' | 'warning' | 'error' => {
    if (type === 'danger') return 'error'
    if (type === 'primary' || type === 'secondary') return 'info'
    return type as 'success' | 'info' | 'warning' | 'error'
  }

  return (
    <div className={styles.alerts}>
      {Object.entries(alerts as Record<string, AlertData>).map(([key, alert]) => (
        <Alert key={key} type={mapAlertType(alert.type)} message={alert.message} onDismiss={() => onDismiss(alert.id)} />
      ))}
    </div>
  )
}

export default Alerts